import { render, staticRenderFns } from "./TheSnackbarQueueHandler.vue?vue&type=template&id=13f7d724&scoped=true&"
import script from "./TheSnackbarQueueHandler.vue?vue&type=script&lang=ts&"
export * from "./TheSnackbarQueueHandler.vue?vue&type=script&lang=ts&"
import style0 from "./TheSnackbarQueueHandler.vue?vue&type=style&index=0&id=13f7d724&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f7d724",
  null
  
)

export default component.exports